import React from 'react'

interface LoadingOverlayProps {
  isVisible: boolean
  message?: string
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ 
  isVisible, 
  message = '載入中...' 
}) => {
  if (!isVisible) return null

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 flex flex-col items-center space-y-4 shadow-xl">
        {/* 轉圈圈動畫 */}
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
        
        {/* 載入文字 */}
        <div className="text-center">
          <p className="text-lg font-medium text-gray-900 mb-1">{message}</p>
          <p className="text-sm text-gray-500">請稍候，系統正在更新設定...</p>
        </div>
      </div>
    </div>
  )
}

export default LoadingOverlay